import { StateEffect, StateField } from '@codemirror/state';
import { Decoration, keymap } from '@codemirror/view';
import { EditorView, basicSetup } from 'codemirror';
import { indentWithTab } from '@codemirror/commands';
import { javascript } from '@codemirror/lang-javascript';
import presets from './presets';
export function getChildren(node) {
    switch (node.type) {
        case 'Program':
            return node.body;
        case 'VariableDeclaration':
            return node.declarations;
        case 'VariableDeclarator':
            return node.init ? [node.id, node.init] : [node.id];
        case 'ExpressionStatement':
            return [node.expression];
        case 'BinaryExpression':
            return [node.left, node.right];
        case 'AssignmentExpression':
            return [node.left, node.right];
        case 'CallExpression':
            return [node.callee, { type: 'arguments', arguments: node.arguments }];
        case 'arguments':
            return node.arguments;
        case 'MemberExpression':
            return [node.object, node.property];
        case 'NewExpression':
            return node.arguments;
        case 'ObjectExpression':
            return node.properties;
        case 'Property':
            return [node.key, node.value];
        case 'FunctionDeclaration':
            return [node.body];
        case 'FunctionExpression':
            return [node.body];
        case 'BlockStatement':
            return node.body;
        case 'ReturnStatement':
            return node.argument ? [node.argument] : [];
        case 'UnaryExpression':
            return [node.argument];
        case 'IfStatement':
            return [node.test, node.consequent];
        case 'ConditionalExpression':
            return [node.test, node.consequent, node.alternate];
        default:
            return [];
    }
}
export function getLabel(node) {
    switch (node.type) {
        case 'Identifier':
            return node.name;
        case 'Literal':
            return node.raw;
        case 'UnaryExpression':
            return node.operator;
        case 'BinaryExpression':
            return node.operator;
        case 'AssignmentExpression':
            return node.operator;
        case 'FunctionDeclaration':
        case 'FunctionExpression': {
            var params = node.params.map(function (param) { return param.name; }).join(',');
            return 'function ' + (node.id && node.id.name || '') + '(' + params + ')';
        }
        default:
            return node.type;
    }
}
export function getElementColor(node) {
    var color = ({
        'Program': 'black',
        'VariableDeclarator': '#414141',
        'arguments': '#63c1f1',
        'BinaryExpression': '#fcbc2a',
        'UnaryExpression': '#fcbc2a',
        'AssignmentExpression': '#fcbc2a',
        'Identifier': '#ff5246',
        'Literal': '#77c63d'
    })[node.type];
    return color || '#232323';
}
export function addEventListenerToTokenList() {
    var tokenList = document.querySelectorAll('.stats-tokens li');
    tokenList.forEach(function (element) { return element.addEventListener('mouseover', tokenHover); });
    tokenList.forEach(function (element) { return element.addEventListener('mouseout', unhighlightRange); });
}
export function unhighlightRange() {
    editorView.dispatch({
        effects: filterMarks.of(null)
    });
}
export function highlightRange(_a) {
    var start = _a[0], end = _a[1];
    if (start === end) {
        // Do not highlight a range of length 0
        return;
    }
    editorView.dispatch({
        effects: highlightMark.of([highlightDecoration.range(start, end)])
    });
}
function tokenHover(e) {
    var li = e.target;
    var range = JSON.parse(li.getAttribute('data-range'));
    unhighlightRange();
    highlightRange(range);
}
export function changePreset() {
    var preset = document.getElementById('select-program');
    var value = preset.value;
    var code = presets[value];
    editorView.dispatch({
        changes: { from: 0, to: editorView.state.doc.length, insert: code }
    });
}
// codemirror
var highlightMark = StateEffect.define();
var filterMarks = StateEffect.define();
var markField = StateField.define({
    create: function () { return Decoration.none; },
    update: function (value, tr) {
        value = value.map(tr.changes);
        for (var _i = 0, _a = tr.effects; _i < _a.length; _i++) {
            var effect = _a[_i];
            if (effect.is(highlightMark))
                value = value.update({ add: effect.value, sort: true });
            else if (effect.is(filterMarks))
                value = value.update({ filter: function () { return false; } });
        }
        return value;
    },
    provide: function (f) { return EditorView.decorations.from(f); }
});
var highlightDecoration = Decoration.mark({
    class: 'highlight',
});
export var editorView = new EditorView({
    extensions: [
        basicSetup,
        keymap.of([indentWithTab]),
        javascript(),
        markField
    ],
    parent: document.getElementById('program')
});
